import React, { Component } from "react";
import TrickOrTreat from "../images/H1_Large.svg";
import TrickOrTreatSmall from "../images/H1_Small.svg";
import Vote from "../images/H2_Large_Vote.svg";
import { Fade } from "react-awesome-reveal";

export default class Hero extends Component {
  render() {
    return (
      <section className="hero" {...this.props}>
        <Fade triggerOnce>
          <div>
            <img
              src={TrickOrTreat}
              alt="TrickOrTreat"
              className="hidden md:block ml-auto mr-auto"
            />
            <img
              src={TrickOrTreatSmall}
              alt="TrickOrTreat"
              className="block md:hidden ml-auto mr-auto mb-10"
            />
          </div>
        </Fade>
        <div className="hero-bg" />
        <Fade triggerOnce>
          <div className="pt-4 lg:-mt-48 lg:ml-20 md:-mt-40 md:ml-10">
            <h6 className="h6">2019 Champion</h6>
            <p className="h5 mb-1">Julian Marin</p>
            <p className="">The Swedish Chef</p>
          </div>
        </Fade>
        <div className="md:mt-40">
          <div className="flex">
            <div className="mt-20 lg:w-1/2 lg:ml-auto lg:pl-20 lg:pr-20 xl:pr-32">
              <Fade triggerOnce>
                <p className="text-2xl leading-10">
                  At Huge Southeast we give a shit about Halloween. And while we
                  have to celebrate a little bit differently than usual this
                  year, we still have traditions to stick to.
                </p>
                <p className="text-2xl leading-10 mt-8">
                  We know these won't be the most important votes you cast this
                  year, but we do promise that in our contests, the popular vote
                  always wins.
                </p>
              </Fade>
              <Fade triggerOnce>
                <img
                  className="mt-24 md:mt-40 mb-4 md:mb-8"
                  src={Vote}
                  alt="Vote"
                />
              </Fade>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
